import React from 'react';
import type { DistributedOmit } from 'type-fest';
import useAppSelector from '../app/redux/useAppSelector';
import type { ButtonProps } from '../components/Button';
import Button from '../components/Button';
import { TopicPrivacy } from '../graphql/generated/graphql';
import topicPolicyCheck, { TopicPolicyAction } from '../topic/topicPolicyCheck';
import { useAllTopicMap } from '../topic/useAllTopics';
import type { LinkProps } from '../utils/router/Link';
import { createPostPath } from '../utils/url/postPath';
import usePublicContentPermissions from '../utils/usePublicContentPermissions';

type CreatePostButtonProps = DistributedOmit<
  ButtonProps & LinkProps & { topicId?: string | null },
  'to'
>;

const CreatePostButton = ({
  children,
  topicId,
  ...props
}: CreatePostButtonProps) => {
  const currentUser = useAppSelector((state) => state.session.user);
  const isLocked =
    useAppSelector((state) => state.session.organization.isLocked) ?? false;
  const { isPermittedToPublicizePost } = usePublicContentPermissions();

  const topicMap = useAllTopicMap();
  const topic = topicId ? topicMap[topicId] : null;

  const canCreatePostInsideTopic =
    !!topic &&
    topicPolicyCheck(TopicPolicyAction.EditPost, topic, currentUser) &&
    (topic.privacy !== TopicPrivacy.Public || isPermittedToPublicizePost);

  return (
    <Button
      {...props}
      to={createPostPath({
        topicId: canCreatePostInsideTopic && topicId ? topicId : undefined,
      })}
      disabled={isLocked}
    >
      {children}
    </Button>
  );
};

export default CreatePostButton;
